module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","state":"Status","stateSensors":"Online sensors","direction":"Direction","length":"Section Length","enabled":"Active","disabled":"Pause","info":"About this section"},"it":{"name":"Nome","state":"Stato","direction":"Direzione","stateSensors":"Sensori online","length":"Lunghezza sezione","enabled":"Attiva","disabled":"In pausa","info":"Informazioni su questo gruppo"}}')
  delete Component.options._Ctor
}
